import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20modern%20entertainment%20platform%20hero%20background%20with%20abstract%20geometric%20playful%20shapes%2C%20warm%20coral%20orange%20and%20soft%20pink%20gradient%2C%20clean%20minimal%20design%2C%20dynamic%20composition%2C%20digital%20media%20streaming%20atmosphere%2C%20bright%20and%20inviting&width=1600&height=800&seq=hero-bg-jiujiu&orientation=landscape"
        alt="久久视频 - 泛娱乐视频平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 leading-tight">
            久久视频，轻松刷不停
          </h1>
          <p className="text-base md:text-lg text-white/85 max-w-xl mx-auto mb-8 leading-relaxed">
            聚合蜜桃视频、樱桃视频、蘑菇视频、茄子视频等泛娱乐内容，<br className="hidden sm:block" />
            综艺、动漫、短视频、搞笑创意视频，免费在线观看
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/gaoxiao"
              className="px-8 py-3 bg-primary-500 text-white rounded-full font-label text-sm font-medium hover:bg-primary-600 cursor-pointer transition-all whitespace-nowrap"
            >
              立即观看
            </Link>
            <Link
              to="/category/zongyi"
              className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full font-label text-sm font-medium hover:bg-white/25 cursor-pointer transition-all whitespace-nowrap"
            >
              热门综艺
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/40 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 rounded-full bg-white/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}